import { useMutation, useQuery } from "@tanstack/react-query";
import { createVendor, getCooperationTypes, getPharmacyType } from "./RegistrationApi";
import useNotification from "hooks/useNotification";

export const useGetCooperationTypes = () => {
  const { data, isLoading } = useQuery(["getCooperationType"], () => getCooperationTypes());
  return { data: data as any, isLoading };
};

export const useGetPharmacyType = () => {
  const { data, isLoading } = useQuery(["getPharmacyType"], () => getPharmacyType());
  return { data: data as any, isLoading };
};

export const useCreateVendor = () => useMutation(["createVendor"], createVendor);
